/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React, { useEffect } from 'react';
import queryString from "query-string";
import { Container } from 'reactstrap';

import RequestLoginErrorMessage from "../../components/RequestLoginErrorMessage";
import ServiceApi from "../../services/ServiceApi";

import "./style.scss";
import LoginForm from "./LoginForm";

import "bootstrap/dist/css/bootstrap.css";

const Login = ({ translate, location }) => {
  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);

  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type)
      return false;
    return true;
  }

  useEffect(() => {
    document.title = 'Login Claro Video';
  }, []);

  return (
    <Container className="claro-video-login" fluid={true} >
      <div className="clarovideo-login">
        <div className="row">
          <div className="col">
            <img
              className="logo-clarovideo"
              src="https://clarovideocdn6-a.akamaihd.net/web/webclient/sk_core/images/clarovideo-logo-sitio.svg"
              alt="Clarovideo"
              width="213"
              height="43"
            />
            {
              _validateParams()
                ? <LoginForm
                  api={api}
                  location={location} />
                : <RequestLoginErrorMessage
                  onlyMessage={true}
                  message={translate('RequestLoginErrorMessage')} />}
          </div>
        </div>
      </div>
    </Container>
  );
}

export default Login;
